import { useEffect, useState } from 'react';
import fleetApi from '../../services/api.service';

export default function useGetFactories() {
  const [factories, setFactories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFactories = async () => {
      try {
        setIsLoading(true);
        const response = await fleetApi.get('/factories');
        if (response.status === 200 && response.data?.data) {
          setFactories(response.data.data);
        }
      } catch (err) {
        setError(err?.message || 'Erreur lors de la récupération des usines');
        console.error('Erreur lors de la récupération des usines:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFactories();
  }, []);

  return {
    factories,
    isLoading,
    error,
  };
}

